// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"526":"locale-sk-json","551":"locale-en-json"}[chunkId] + ".min.js";
};